<template>
  <div class="file-catalog-panel">
    <el-form :inline="true" :model="query" size="small" class="search-form" @submit.native.prevent>
      <el-form-item label="一级文件夹">
        <el-input v-model="query.folderLevel1" clearable placeholder="如：程序文件" />
      </el-form-item>
      <el-form-item label="二级文件夹">
        <el-input v-model="query.folderLevel2" clearable placeholder="二级目录名" />
      </el-form-item>
      <el-form-item label="文件编号">
        <el-input v-model="query.fileCode" clearable placeholder="如：RY-PD-001" />
      </el-form-item>
      <el-form-item label="文件名称">
        <el-input v-model="query.fileName" clearable placeholder="文件名称" />
      </el-form-item>
      <el-form-item label="版本号">
        <el-input v-model="query.version" clearable placeholder="如：G0" style="width: 100px;" />
      </el-form-item>
      <el-form-item label="编制人">
        <el-input v-model="query.preparer" clearable placeholder="编制人" style="width: 110px;" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="sort-tip">
      <i class="el-icon-rank"></i>
      拖拽左侧手柄可调整本页排序；排序按全局 sort_no 生效（越小越靠前）
    </div>

    <el-table
      ref="catalogTable"
      :data="tableData"
      v-loading="loading || sorting"
      row-key="fileId"
      border
      stripe
      height="calc(100vh - 290px)"
      class="catalog-table"
    >
      <el-table-column label="" width="46" align="center" class-name="drag-col">
        <template>
          <span class="drag-handle" title="拖拽排序">
            <i class="el-icon-rank"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="sortNo" label="排序号" width="70" align="center" />
      <el-table-column prop="folderLevel1" label="一级文件夹" min-width="110" show-overflow-tooltip />
      <el-table-column prop="folderLevel2" label="二级文件夹" min-width="110" show-overflow-tooltip />
      <el-table-column prop="fileCode" label="文件编号" min-width="120" show-overflow-tooltip />
      <el-table-column prop="fileName" label="程序文件名称" min-width="180" show-overflow-tooltip />
      <el-table-column prop="version" label="版本号" width="90" align="center" />
      <el-table-column prop="effectiveDate" label="生效日期" width="120" align="center" />
      <el-table-column prop="createDate" label="上传日期" width="160" align="center" />
      <el-table-column prop="preparer" label="编制" width="90" align="center" show-overflow-tooltip />
      <el-table-column prop="reviewer" label="审核" width="90" align="center" show-overflow-tooltip />
      <el-table-column prop="approver" label="批准" width="90" align="center" show-overflow-tooltip />
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      <el-table-column label="预览权限" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.hasViewPermission ? 'success' : 'info'" size="mini">
            {{ scope.row.hasViewPermission ? '有权限' : '无权限' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="canEdit" label="操作" width="100" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openEdit(scope.row)">编辑版本</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top: 16px; text-align: right;"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      :current-page="query.curPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="query.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <el-dialog title="编辑文件台账信息" :visible.sync="editVisible" width="560px" append-to-body :close-on-click-modal="false">
      <el-form ref="editFormRef" :model="editForm" :rules="editRules" label-width="100px" size="small">
        <el-form-item label="文件名称" prop="fileName">
          <el-input v-model="editForm.fileName" maxlength="200" />
        </el-form-item>
        <el-form-item label="文件编号" prop="fileCode">
          <el-input v-model="editForm.fileCode" maxlength="64" placeholder="如：RY-PD-001" />
        </el-form-item>
        <el-form-item label="版本号" prop="version">
          <el-input v-model="editForm.version" maxlength="32" placeholder="如：G0 / V1.0" />
        </el-form-item>
        <el-form-item label="生效日期" prop="effectiveDate">
          <el-date-picker
            v-model="editForm.effectiveDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择生效日期"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="编制人" prop="preparer">
          <select-member-modal
            v-model="editForm.preparer"
            placeholder="请选择编制人"
            :multiple="false"
            :trigger-change="true"
            value-field="fullName"
            :popover-z-index="5000"
          />
        </el-form-item>
        <el-form-item label="审核人" prop="reviewer">
          <select-member-modal
            v-model="editForm.reviewer"
            placeholder="请选择审核人"
            :multiple="false"
            :trigger-change="true"
            value-field="fullName"
            :popover-z-index="5000"
          />
        </el-form-item>
        <el-form-item label="批准人" prop="approver">
          <select-member-modal
            v-model="editForm.approver"
            placeholder="请选择批准人"
            :multiple="false"
            :trigger-change="true"
            value-field="fullName"
            :popover-z-index="5000"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" :rows="2" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="排序号" prop="sortNo">
          <el-input-number v-model="editForm.sortNo" :min="0" :max="999999999" controls-position="right" style="width: 100%;" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" :loading="saving" @click="saveEdit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'fileCatalogPanel',
  components: {
    SelectMemberModal: () => import('@/components/SelectMemberModal.vue')
  },
  props: {
    /** 与「默认白名单」相同：addFileButton 或 canOperateAll */
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      saving: false,
      sorting: false,
      tableData: [],
      total: 0,
      dragIndex: -1,
      query: {
        folderLevel1: '',
        folderLevel2: '',
        fileCode: '',
        fileName: '',
        version: '',
        preparer: '',
        curPage: 1,
        pageSize: 20
      },
      editVisible: false,
      editForm: {
        fileId: '',
        fileName: '',
        fileCode: '',
        version: '',
        effectiveDate: '',
        preparer: '',
        reviewer: '',
        approver: '',
        remark: '',
        sortNo: 0
      },
      editRules: {
        version: [{ required: true, message: '请输入版本号', trigger: 'blur' }]
      },
      _dragBound: false
    }
  },
  created() {
    this.loadData()
  },
  updated() {
    this.bindRowDrag()
  },
  beforeDestroy() {
    this.unbindRowDrag()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$HttpService.post('/file-info/catalog/page', { ...this.query })
        .then(res => {
          const page = res || {}
          this.tableData = page.records || page.list || []
          this.total = page.total != null ? Number(page.total) : 0
          this.$nextTick(() => this.bindRowDrag())
        })
        .finally(() => {
          this.loading = false
        })
    },
    refresh() {
      this.loadData()
    },
    handleSearch() {
      this.query.curPage = 1
      this.loadData()
    },
    handleReset() {
      this.query = {
        folderLevel1: '',
        folderLevel2: '',
        fileCode: '',
        fileName: '',
        version: '',
        preparer: '',
        curPage: 1,
        pageSize: this.query.pageSize
      }
      this.loadData()
    },
    handleSizeChange(size) {
      this.query.pageSize = size
      this.query.curPage = 1
      this.loadData()
    },
    handlePageChange(page) {
      this.query.curPage = page
      this.loadData()
    },
    getTbody() {
      const table = this.$refs.catalogTable
      if (!table || !table.$el) return null
      return table.$el.querySelector('.el-table__body-wrapper tbody')
    },
    unbindRowDrag() {
      const tbody = this._dragTbody
      if (!tbody || !this._dragHandlers) return
      const h = this._dragHandlers
      tbody.removeEventListener('dragstart', h.dragstart)
      tbody.removeEventListener('dragover', h.dragover)
      tbody.removeEventListener('drop', h.drop)
      tbody.removeEventListener('dragend', h.dragend)
      this._dragBound = false
      this._dragTbody = null
      this._dragHandlers = null
    },
    bindRowDrag() {
      const tbody = this.getTbody()
      if (!tbody) return
      if (this._dragBound && this._dragTbody === tbody) {
        this.markRowsDraggable(tbody)
        return
      }
      this.unbindRowDrag()
      const handlers = {
        dragstart: (e) => this.onDragStart(e),
        dragover: (e) => this.onDragOver(e),
        drop: (e) => this.onDrop(e),
        dragend: (e) => this.onDragEnd(e)
      }
      tbody.addEventListener('dragstart', handlers.dragstart)
      tbody.addEventListener('dragover', handlers.dragover)
      tbody.addEventListener('drop', handlers.drop)
      tbody.addEventListener('dragend', handlers.dragend)
      this._dragBound = true
      this._dragTbody = tbody
      this._dragHandlers = handlers
      this.markRowsDraggable(tbody)
    },
    markRowsDraggable(tbody) {
      Array.from(tbody.querySelectorAll('tr')).forEach(tr => {
        tr.removeAttribute('draggable')
        const handle = tr.querySelector('.drag-handle')
        if (handle) {
          handle.setAttribute('draggable', 'true')
        }
      })
    },
    onDragStart(e) {
      const handle = e.target.closest('.drag-handle')
      if (!handle) return
      const tr = handle.closest('tr')
      const tbody = this.getTbody()
      if (!tr || !tbody) return
      this.dragIndex = Array.from(tbody.children).indexOf(tr)
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.setData('text/plain', String(this.dragIndex))
      tr.classList.add('is-dragging')
    },
    onDragOver(e) {
      e.preventDefault()
      e.dataTransfer.dropEffect = 'move'
      const tr = e.target.closest('tr')
      if (!tr) return
      const tbody = this.getTbody()
      Array.from(tbody.children).forEach(row => row.classList.remove('is-drag-over'))
      tr.classList.add('is-drag-over')
    },
    onDrop(e) {
      e.preventDefault()
      const tr = e.target.closest('tr')
      const tbody = this.getTbody()
      if (!tr || !tbody || this.dragIndex < 0) return
      const dropIndex = Array.from(tbody.children).indexOf(tr)
      Array.from(tbody.children).forEach(row => row.classList.remove('is-drag-over'))
      if (dropIndex < 0 || dropIndex === this.dragIndex) return
      const list = this.tableData.slice()
      const [moved] = list.splice(this.dragIndex, 1)
      list.splice(dropIndex, 0, moved)
      this.tableData = list
      this.persistSort()
    },
    onDragEnd() {
      this.dragIndex = -1
      const tbody = this.getTbody()
      if (!tbody) return
      Array.from(tbody.children).forEach(row => {
        row.classList.remove('is-dragging', 'is-drag-over')
      })
    },
    persistSort() {
      const base = (this.query.curPage - 1) * this.query.pageSize
      const items = this.tableData.map((row, index) => {
        const sortNo = base + index + 1
        this.$set(row, 'sortNo', sortNo)
        return { fileId: row.fileId, sortNo }
      })
      this.sorting = true
      this.$HttpService.put('/file-info/catalog/sort', { items })
        .then(() => {
          this.$message.success('排序已保存')
        })
        .catch(() => {
          this.$message.error('排序保存失败')
          this.loadData()
        })
        .finally(() => {
          this.sorting = false
          this.$nextTick(() => this.bindRowDrag())
        })
    },
    openEdit(row) {
      this.editForm = {
        fileId: row.fileId,
        fileName: row.fileName || '',
        fileCode: row.fileCode || '',
        version: row.version || '',
        effectiveDate: row.effectiveDate || '',
        preparer: row.preparer || '',
        reviewer: row.reviewer || '',
        approver: row.approver || '',
        remark: row.remark || '',
        sortNo: row.sortNo != null ? Number(row.sortNo) : 0
      }
      this.editVisible = true
      this.$nextTick(() => {
        this.$refs.editFormRef && this.$refs.editFormRef.clearValidate()
      })
    },
    saveEdit() {
      this.$refs.editFormRef.validate(valid => {
        if (!valid) return
        this.saving = true
        this.$HttpService.put('/file-info/catalog/update', { ...this.editForm })
          .then(() => {
            this.$message.success('保存成功')
            this.editVisible = false
            this.loadData()
          })
          .finally(() => {
            this.saving = false
          })
      })
    }
  }
}
</script>

<style scoped>
.file-catalog-panel {
  width: 100%;
  padding: 12px 16px 16px;
  box-sizing: border-box;
}
.search-form {
  margin-bottom: 4px;
}
.sort-tip {
  margin: 0 0 10px;
  color: #909399;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.drag-handle {
  cursor: grab;
  color: #909399;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
}
.drag-handle:hover {
  color: #1e6fff;
  background: rgba(30, 111, 255, 0.08);
}
.drag-handle:active {
  cursor: grabbing;
}
.file-catalog-panel ::v-deep .ant-select {
  width: 100%;
  min-width: 0 !important;
}
</style>

<style>
.catalog-table .is-dragging {
  opacity: 0.55;
  background: #f0f7ff !important;
}
.catalog-table .is-drag-over {
  box-shadow: inset 0 2px 0 #1e6fff;
}
.catalog-table .drag-col .cell {
  padding-left: 0;
  padding-right: 0;
}
</style>
